import { jsxs as n, jsx as c } from "../../_virtual/jsx-runtime.mjs";
import { useMemo as o } from "react";
import { loopSvg as h, loopCircle as m } from "./css/ReoAccordion.mjs";
import "../../assets/css/font.css.ts.vanilla.mjs";
import { fontColor as i } from "../../assets/css/color.mjs";
const f = (e) => {
  const s = o(
    () => e.color ?? i.normal600,
    [e.color]
  ), a = o(
    () => e.activeColor ?? i.active100,
    [e.activeColor]
  ), r = o(() => {
    const t = Number(e.size);
    return {
      width: t,
      viewBox: `0 0 ${t} ${t}`,
      r: `${(t - 1) / 2}px`,
      cx: t / 2,
      cy: t / 2,
      circleLen: (t - 1) * Math.PI,
      strokeDasharray: `${(t - 1) * Math.PI}px, ${(t - 1) * Math.PI}`
    };
  }, [e.size]), l = o(() => ({
    "--stroke-dasharray": r.circleLen,
    ...e.style
  }), [e.style, r.circleLen]);
  return /* @__PURE__ */ n(
    "svg",
    {
      width: r.width,
      height: r.width,
      viewBox: r.viewBox,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className: h,
      children: [
        /* @__PURE__ */ c(
          "circle",
          {
            stroke: s,
            r: r.r,
            cx: r.cx,
            cy: r.cy,
            strokeWidth: "1",
            fill: "transparent"
          }
        ),
        /* @__PURE__ */ c(
          "circle",
          {
            stroke: a,
            r: r.r,
            cx: r.cx,
            cy: r.cy,
            strokeLinecap: "round",
            strokeWidth: "1",
            fill: "transparent",
            strokeDasharray: r.strokeDasharray,
            className: m,
            style: l
          }
        )
      ]
    }
  );
};
export {
  f as default
};
//# sourceMappingURL=Circle.mjs.map
